import { render } from "./StandardImgUpload.vue?vue&type=template&id=ab2823fc&scoped=true"
import script from "./StandardImgUpload.vue?vue&type=script&lang=js"
export * from "./StandardImgUpload.vue?vue&type=script&lang=js"

import "./StandardImgUpload.vue?vue&type=style&index=0&id=ab2823fc&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2823fc"]])

export default __exports__